import { memo, useCallback, useState } from "react";
import GenericTable from "../../../Component/BuyingJourneyDataTable/GenericTable";
import { useIsSelectedSection } from "../discovery-context";
import { tab } from "../BrandScore/BrandScore";
import { ENTITY_LABELS } from "../../../utils/labelMapping";

const TableWrapper = memo(function TableWrapper({
    data,
    title,
    loading,
    error,
    minWidth = "99%",
    sources,
    rawData,
    rawSearchData,
    id,
    discoveryCtx,
    selectedCategory,
    primaryLLM,
    primaryMarket,
    isPrimaryCategory,
    type,
    isFirstPdfTable
}) {

    const [open, setOpen] = useState(false);

    const uniqueKey =
        `${tab[selectedCategory]}_${id}_${primaryLLM}_${primaryMarket}`;

    const { checked } = useIsSelectedSection({
        id,
        uniqueKey,
    });

    const shouldShowCheckbox =
        isPrimaryCategory || id.startsWith("Category_");

    const transformDiscussionData = (arr) => {
        if (!arr || arr.length === 0) return;

        return arr.map((obj) => {
            const mainKey = Object.keys(obj).find(
                (k) => k !== "rating" && k !== "explanation" && k !== "sources"
            );

            return {
                // [mainKey]: `${obj?.[mainKey]}-${obj?.rating}`,
                [mainKey]: `${obj?.[mainKey]}`,
                explanation: obj?.explanation,
                sources: obj?.sources || [], // Preserve sources if they exist, otherwise empty array
            };
        });
    };

    function dynamicReplace(text) {
        let result = text;

        const replacements = {
            "Product":ENTITY_LABELS.product,
            "Brand": ENTITY_LABELS.brand,
            "Buying Journey": ENTITY_LABELS.buyingJourney,
            "Post-Purchase": ENTITY_LABELS.postPurchase,
            'Customer': ENTITY_LABELS.customer,
            "Purchase": ENTITY_LABELS.purchase,
        };

        Object.keys(replacements).forEach((key) => {
            const regex = new RegExp(key, "gi"); // case-insensitive
            result = result.replace(regex, replacements[key]);
        });

        return result;
    }

    const handleReportToggle = useCallback(() => {
        discoveryCtx.clickComponentCheckbox({
            uniqueKey,
            checked,
            filter: {
                id,
                title,
                tab: tab.conversation,
                market: primaryMarket,
                category: selectedCategory,
                uniqueKey,
            },
        });
    }, [checked, discoveryCtx, id, title, uniqueKey, primaryMarket, selectedCategory]);

    return (
        <div style={{ flex: 1, minWidth }}>
            <GenericTable
                sources={sources}
                data={
                    title === `${type} Buying Journey Prompts` ||
                        title === "Category Buying Journey Prompts"
                        ? data
                        : transformDiscussionData(data)
                }
                loading={loading}
                title={dynamicReplace(title)}
                error={error}
                open={open}
                setOpen={setOpen}
                rawData={rawData}
                rawSearchData={rawSearchData}
                id={id}
                showReportCheckbox={
                    discoveryCtx.state.showReportCheckbox && shouldShowCheckbox
                }
                isChecked={checked}
                onReportToggle={handleReportToggle}
                isFirstPdfTable={isFirstPdfTable}
            />
        </div>
    );
});

export default TableWrapper;
